type ManagerProfileOrganization = {
  uuid: string;
  name: string;
};

// picture/gender are always null from the real backend today — Manager (bfb_management/models.py)
// has no such fields at all. Kept here (not omitted) because HeaderActions needs a defined shape
// to fall back on, and the gap is a real, documented backend ask (see docs/organization-dashboard.md).
class ManagerProfile {
  constructor(
    readonly uuid: string,
    readonly email: string,
    readonly firstName: string,
    readonly lastName: string,
    readonly language: string,
    readonly organization: ManagerProfileOrganization | null,
    readonly picture: { photo: string } | null,
    readonly gender: string | null,
  ) {}

  static create({
    uuid,
    email,
    firstName,
    lastName,
    language,
    organization = null,
    picture = null,
    gender = null,
  }: {
    uuid: string;
    email: string;
    firstName: string;
    lastName: string;
    language: string;
    organization?: ManagerProfileOrganization | null;
    picture?: { photo: string } | null;
    gender?: string | null;
  }): ManagerProfile {
    return new ManagerProfile(
      uuid,
      email,
      firstName,
      lastName,
      language,
      organization,
      picture,
      gender,
    );
  }
}

export { ManagerProfile };
export type { ManagerProfileOrganization };
